import { useCallback, useEffect, useState } from "react";

import ErrorsString from "../ErrorsString";
import Spinner from "./Spinner";
import Alert from "@mui/material/Alert";
import "swiper/css";
import "swiper/css/pagination";
import { GetTextHomeModel } from "../models/GetTextHomeModel";

interface Props {
  idPage: string;
}

export default function TextHome(props: Props) {
  let [alertMessage, setAlertMessage] = useState<string>("");
  let [showAlert, setShowAlert] = useState<boolean>(false);
  const [spinnerVisibility, setSpinnerVisibility] = useState(false);
  //let [isLogged, setIsLogged] = useState<boolean>(false);
  let [textHp, setTextHp] = useState<string>("");

  const getTextHome = useCallback(() => {
    window.scrollTo(0, 0);
    setSpinnerVisibility(true);

    (async () => {
      let response = null;
      response = await GetTextHomeModel(props.idPage);

      /* if (isLoggedIn) {
        console.log("Starting API call GetCarouselWoModel...");
        response = await GetCarouselWoModel(props.idPage);
      } else {
        console.log("Starting API call GetCarouselPublicWoModel...");
        response = await GetCarouselPublicWoModel(props.idPage);
      } */

      //console.log("GetCarouselWoModel response: " + response);
      const responseData = response?.data;
      const statusCode = response?.status;

      if (responseData === undefined) {
        setShowAlert(true);
        setAlertMessage(ErrorsString.errorMessageGeneric);
        setSpinnerVisibility(false);
        return;
      }

      if (statusCode !== 200) {
        setShowAlert(true);
        setAlertMessage(ErrorsString.errorMessageGeneric);
        setSpinnerVisibility(false);
        return;
      }

      if (responseData.code !== "0") {
        setShowAlert(true);
        setAlertMessage(responseData.message);
        setSpinnerVisibility(false);
        return;
      }

      if (responseData.textHome) {
        setTextHp(responseData.textHome);
        setShowAlert(false);
        setAlertMessage("");
        setSpinnerVisibility(false);
      } else {
        setShowAlert(true);
        setTextHp("");
        setSpinnerVisibility(false);
      }
    })();
  }, [props.idPage]);

  useEffect(() => {
    getTextHome();
  }, [getTextHome]);

  return (
    <>
      <Spinner visibility={spinnerVisibility} />
      {textHp ? (
        <div
          id="text-home"
          className="px-2 mt-10"
          dangerouslySetInnerHTML={{ __html: textHp }}
        ></div>
      ) : (
        <Alert
          data-test-id="text-home-error"
          severity="error"
          style={{
            display: showAlert ? "flex" : "none",
          }}
        >
          {alertMessage}
        </Alert>
      )}
    </>
  );
}
